export default {
  loading: false,
  featuredVehicles: {
    items: [],
    loading: false,
  },
};
